import moment from 'moment';

class TcCalendarModalController {
  constructor($scope, $uibModalInstance, minDate, maxDate) {
    "ngInject";

    this.$uibModalInstance = $uibModalInstance;

    // Set up current month and date navigation
    $scope.currentMonth = moment();
    $scope.selectedYear = $scope.currentMonth.year(); // Track the currently displayed year
    $scope.selectedMonth = $scope.currentMonth.month(); // Track the currently displayed month (0-11)
    $scope.dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    // Generate the range of available years
    $scope.availableYears = [];
    const startYear = minDate ? minDate.year() : moment().year() - 10; // 10 years before current year or minDate
    const endYear = maxDate ? maxDate.year() : moment().year() + 10;  // 10 years after current year or maxDate
    for (let year = startYear; year <= endYear; year++) {
      $scope.availableYears.push(year);
    }

    // Generate available months (0-11 for January-December)
    $scope.availableMonths = [];
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 
                        'July', 'August', 'September', 'October', 'November', 'December'];
    for (let i = 0; i < 12; i++) {
      $scope.availableMonths.push({ value: i, name: monthNames[i] });
    }

    // Logic to enable/disable next/previous buttons
    const updateControls = () => {
      // Disable next/previous month buttons as per bounds
      $scope.disableNextMonth = maxDate && $scope.currentMonth.clone().add(1, 'month').isAfter(maxDate, 'month');
      $scope.disablePreviousMonth = minDate && $scope.currentMonth.clone().subtract(1, 'month').isBefore(minDate, 'month');
    };

    // Generate the days for the calendar
    const generateCalendarDays = () => {
      const startOfMonth = $scope.currentMonth.clone().startOf('month');
      const endOfMonth = $scope.currentMonth.clone().endOf('month');

      $scope.daysInMonth = [];

      // Add placeholders for days of the previous month
      const firstDayOfWeek = startOfMonth.day(); // 0 (Sunday) to 6 (Saturday)
      for (let i = 0; i < firstDayOfWeek; i++) {
        $scope.daysInMonth.push({
          date: null,
          isPlaceholder: true,
          isDisabled: true,
        });
      }

      // Populate the month days
      let date = startOfMonth.clone();
      while (date.isSameOrBefore(endOfMonth, 'day')) {
        const dateClone = date.clone().startOf('day');
        const isBeforeMin = minDate ? dateClone.isBefore(minDate, 'day') : false;
        // Check if date is strictly after maxDate (dates equal to maxDate should be allowed)
        const isAfterMax = maxDate ? dateClone.isAfter(maxDate, 'day') : false;
        
        $scope.daysInMonth.push({
          date: dateClone,
          isToday: dateClone.isSame(moment(), 'day'),
          isWeekend: dateClone.isoWeekday() >= 6, // Saturday or Sunday
          isPlaceholder: false,
          isDisabled: isBeforeMin || isAfterMax, // Outside min/max bounds
        });
        date.add(1, 'day');
      }

      // Fill remaining days to complete the week
      const lastDayOfWeek = endOfMonth.day();
      for (let i = lastDayOfWeek + 1; i <= 6; i++) {
        $scope.daysInMonth.push({
          date: null,
          isPlaceholder: true,
          isDisabled: true,
        });
      }

      // Update button states and selected month
      updateControls();
      $scope.selectedMonth = $scope.currentMonth.month();
    };

    // Navigation methods
    $scope.previousMonth = () => {
      $scope.currentMonth.subtract(1, 'month');
      $scope.selectedYear = $scope.currentMonth.year();
      $scope.selectedMonth = $scope.currentMonth.month();
      generateCalendarDays();
    };

    $scope.nextMonth = () => {
      $scope.currentMonth.add(1, 'month');
      $scope.selectedYear = $scope.currentMonth.year();
      $scope.selectedMonth = $scope.currentMonth.month();
      generateCalendarDays();
    };

    // Handle year dropdown changes
    $scope.onYearChange = () => {
      $scope.currentMonth.year($scope.selectedYear);
      generateCalendarDays();
    };

    // Handle month dropdown changes
    $scope.onMonthChange = () => {
      $scope.currentMonth.month($scope.selectedMonth);
      $scope.selectedYear = $scope.currentMonth.year();
      generateCalendarDays();
    };

    // Date selection
    $scope.selectDate = (day) => {
      if (!day.isDisabled && !day.isPlaceholder && day.date) {
        // Double-check the date is within bounds before allowing selection
        const dateToCheck = moment(day.date).startOf('day');
        const isBeforeMin = minDate ? dateToCheck.isBefore(minDate, 'day') : false;
        const isAfterMax = maxDate ? dateToCheck.isAfter(maxDate, 'day') : false;
        
        if (!isBeforeMin && !isAfterMax) {
          $uibModalInstance.close(day.date); // Close modal and pass the selected date
        }
      }
    };

    // Close the modal
    $scope.closeModal = () => {
      $uibModalInstance.dismiss('cancel');
    };

    // Initial calendar setup
    generateCalendarDays();
  }
}

export default TcCalendarModalController;



// WEBPACK FOOTER //
// ./client/common/directives/calendar/tc-calendar.controller.js